import { render, staticRenderFns } from "./StockOut.vue?vue&type=template&id=2fabd05c&scoped=true&"
import script from "./StockOut.vue?vue&type=script&lang=js&"
export * from "./StockOut.vue?vue&type=script&lang=js&"
import style0 from "./StockOut.vue?vue&type=style&index=0&id=2fabd05c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabd05c",
  null
  
)

export default component.exports